import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ApiRegistryService } from '../../../services/api-registry.service';
import { ApiParametrosService } from '../../../services/api-parametros.service';
import { ApiAuthService } from '../../../services/api-auth.service';
import { Proveedor } from '../../../models/Proveedor';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FiltroItemsPipe } from '../../../pipes/filtro-items.pipe';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

declare var $: any;

@Component({
  selector: 'app-registro-usuarios',
  templateUrl: './registro-usuarios.component.html',
  styleUrls: ['./registro-usuarios.component.css']
})
export class RegistroUsuariosComponent implements OnInit {

  tipoPersona: string = 'M';
  radioProveedor: string = 'S';
  //Para los input de Datos Generales
  txtRazonSocial: string = '';
  txtNombreComercial: string = '';
  selGiro: string = '-1';
  ///GRADO DE ESTUDIOS
  selNivel:string = '6';
  ///GRADO DE ESTUDIOS
  txtNumCedula:string = '';
  ///PAIS
  selPais:string = '1';
  classPais:string = '';
  datapaises: any[] = [];
  //Estado
  selEstado:string = '1';
  classEdo:string = '';
  dataestados: any[] = [];
  //Ciudad
  selCiud:string = '';
  classCiud:string = '';
  dataciud: any[] = [];
  ciudDescri:string='';
  classciudDescri:string='';
  //
  radioSexo:string = '1';
  //
  fechaNacimiento:string = '';
  fecha = new Date();
  año   = this.fecha.getFullYear()-18;//Para que sea mayor de edad
  maxfechaNac = this.año+'-12-31';
  classfechaNac:string = '';

  selEstratificacion: string = '-1';
  selRepresentante: string = '1';
  selAsentamiento: string = '';
  selVialidad: string = '1';
  subcontratacion: string = '0';
  txtObjetoSocial: string = '';
  txtNoCeduPadr: string = '';
  txtRepreLeg: string = '';
  txtCurpRepTec: string = '';
  txtCurpRepLegal: string = '';
  txtApePatRepreLeg: string = '';
  txtApeMatRepreLeg: string = '';
  txtRepreTec: string = '';
  txtApePatRepreTec: string = '';
  txtApeMatRepreTec: string = '';
  txtCurpF: string = '';
  txtNombreF: string = '';
  txtApePatF: string = '';
  txtApeMatF: string = '';
  txtActiEmp: string = '';
  txtNoCeduPadrF: string = '';
  //Para los inputs de la informacion de usuarios
  //Domicilio Fiscal
  txtCalle: string = '';
  txtNumero: string = '';
  txtInterior: string = '';
  txtCP: string = '';
  txtNumTel1: string = '';
  selColonia: string = '-1';
  selCiudadMuni: string = '-1';
  selEstados: string = '-1';
  //Contacto
  txtCurp: string = '';
  txtNombre: string = '';
  txtApePat: string = '';
  txtApeMat: string = '';
  txtCorreElec: string = '';
  txtTelef: string = '';
  txtMovil: string = '';
  txtCorreEmpre: string = '';
  txtPaginaWeb: string = '';
  //Datos Bancarios
  txtCuenta: string = '';
  txtCuentaClabe: string = '';
  selBanco: string = '-1';
  //Para las clases de inputs vacios
  razonSocial: string = '';
  nombreComercial: string = '';
  giro: string = '';
  //ASOLEDAD 04/02/2022 gRADO DE ESTUDIOS
  grado: string = '';
  //asoledad 19/05/2022 Cedula Profesional
  numcedula: string = '';
  ocultaCed: boolean = false;

  estrati: string = '';
  colon: string = '';
  objetoSocial: string = '';
  noCeduPadr: string = '';
  repreLeg: string = '';
  apePatRepreLeg: string = '';
  apeMatRepreLeg: string = '';
  curpRepTec: string = '';
  curpRepLegal: string = '';
  correoRepL: string ='';
  telefonoRepL: string = '';
  telcelRepL: string = '';
  correoRepT: string = '';
  telefonoRepT: string = '';
  telcelRepT: string = '';
  repreTec: string = '';
  apePatRepreTec: string = '';
  apeMatRepreTec: string = '';
  curpF: string = '';
  nombreF: string = '';
  apePatF: string = '';
  apeMatF: string = '';
  actiEmp: string = '';
  noCeduPadrF: string = '';
  //Para las clases en en Domicilio Fiscal
  calle: string = '';
  numero: string = '';
  interior: string = '';
  cp: string = '';
  vialidadClass: string = '';
  disabledCp: boolean = true;
  spinn: string = '';
  spinner: string = 'uaa-none';
  numtel1: string = '';
  //Contacto
  curp: string = '';
  nombre: string = '';
  apePat: string = '';
  apeMat: string = '';
  correElec: string = '';
  telef: string = '';
  movil: string = '';
  correEmpre: string = '';
  //Bancarios
  banc: string = '';
  cuenta: string = '';
  cuentaClabe: string = '';

  estados: any[] = [];
  municipios: any[] = [];
  colonias: any[] = [];
  giros: any[] = [];
  grados: any[] = [];
  estratificacion: any[] = [];
  bancos: any[] = [];
  representantes: any[] = [];
  vialidad: any[] = [];
  asentamiento: any[] = [];
  desactivaDatosCt: boolean = true;
  fcccuba: string = '';
  fkcprco: string = '';
  fkcpers: string = '';
  fkcpersRl: string = '';
  fkcpersRt: string = '';
  fkcpersCt: string = '';
  telefonoRl: string = '';
  telcelRl: string = '';
  correoRl: string = '';
  telefonoRt: string = '';
  telcelRt: string = '';
  correoRt: string = '';
  radioSituacion: string = '2';
  radioTipo: string = 'S';
  tipo:string = '0';
  //Patron que se ejecuta en el ingreso del email en el input
  emailPattern: any = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //Patron que se ejecuta en el ingreso de la CURP en el input
  curpPattern: any = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0\d|1[0-2])(?:[0-2]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;

  //BLOQUEA EDICION DE CAMPOS
  public bloquea: boolean = false;
  public bloqTip: boolean = false;
  //ERRORES
  public errorCorreo: string = '';
  public errorCorreoEmp: string = '';
  public errorCorreoRl: string = '';
  public errorCorreoRt: string = '';
  public errorCurpRl: string = '';
  public errorCurpRt: string = '';
  public errorCurp: string = '';

  public mensajeError: string = '¡Error!';
  public errorCamposInc: boolean = false;
  public error: number;

  public errorCLABE: string = '';
  public errorCuenta:string = '';
  //TEXTO ETIQUETA
  etiquetrepr: string = 'REPRESENTANTE LEGAL';
  etiquetCveProv: string = '';
  etiquetaEstatus: string = '';
  etiquetaTitulo: string = 'Pre-registro de Proveedores, Contratistas y Prestadores de Servicio';

  @Input() public id: number;
  @Input() public titulo: number;

   datagiros: any[] = []; //Guarda los giros
   datagrados: any[] = []; //Guarda los giros

   //Creacion del FormGroup con sus determinados campos y sus validators.
  createFormGroup() {
    return new FormGroup({
      correoContacto: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern)]),
      correoEmpresa: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern)]),
      correoRl: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern)]),
      correoRt: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern)]),
      curpRl: new FormControl('', [Validators.required, Validators.pattern(this.curpPattern)]),
      curpRt: new FormControl('', [Validators.required, Validators.pattern(this.curpPattern)]),
      curp: new FormControl('', [Validators.required, Validators.pattern(this.curpPattern)])
    });
  }

  contactForm: FormGroup;
  constructor(private router: Router,private apiRegistry: ApiRegistryService, private apiParam: ApiParametrosService, private apiAuth: ApiAuthService) {
    this.contactForm = this.createFormGroup();
    this.tipoPersona += this.radioProveedor;
//    console.log(this.router.routerState.snapshot.url);
    let url = this.router.routerState.snapshot.url;

    //Si el proveedor ya tiene informacion
    if (url === '/registro-usuarios/1') {
      //Carga información guardada
      this.tipo = '1';
      this.cargaInformacion();
    } else if (url === '/registro-usuarios/0') { //Si el proveedor no tiene informacion
      this.tipo = '0';
      let proveedor: Proveedor;
      proveedor = this.apiAuth.getTokenDecoded();
      this.apiRegistry.getInformacionRfc(proveedor.RFC).subscribe(data => {
        if (data[0].success) {
          console.log("Info "+data[0].info);
          if (data[0].info !== '{}' && data[0].info !== '[]') {
            let datos = data[0].info;
            datos = JSON.parse(datos);
            this.etiquetCveProv = datos[0].CLAVEPROV;
            this.etiquetaEstatus = datos[0].ESTATUS_DESCRI;
            this.cargaDatos(datos);
            setTimeout(() => {
              $('#mod_procesando').modal('hide');
           }, 500);
          } else {
            //Seleccionar Situacion Fiscal con respescto a su RFC  12 digitos -> MORAL, 13 digitos -> FISICA
            if (proveedor.RFC.length === 12) {
              this.radioSituacion = '2';
            } else if (proveedor.RFC.length === 13) {
              this.radioSituacion = '1';
            }
            let radioSit = this.radioSituacion == '1' ? 'F' : 'M';
            this.tipoPersona = radioSit + this.radioTipo;
            //console.log("Radios:"+this.radioTipo+" Tipo "+proveedor.TipoProv);
          }
        } else {
          this.mensajeError = data[0].msgRespuesta;
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
            $('#error').modal('show');
         }, 500);
        }
        //this.getGiros();
        this.getEstratificacion();
      },
      error => {
        this.error = error.status;
        if (error.status === 401) {
          this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
        } else  {
          this.mensajeError = '¡Error!';
        }
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
       }, 500);
      });

    }
  }

  ngOnInit() {
    if (this.titulo === 1){
        this.etiquetaTitulo = 'Perfil';
    }
    if (this.id === 1) {
      this.cargaInformacion();
    }
    $('#mod_procesando').modal('show');
  }

  //Obtiene los giros
  getGiros() {
    this.datagiros = [];
    let cveLov = 'LOVGIROSAO';
    let tipoProv = this.radioProveedor == 'S' ? 1 : this.radioProveedor == 'O' ? 2 :this.radioProveedor == 'A' ? 3:4;
    let cadena = 'VPS_TIPOPROV:cadena=' + tipoProv;
    this.apiRegistry.getLovs(cveLov, cadena).subscribe(data => {
      if (data[0].success) {
        let gir = data[0].info;
        this.giros = JSON.parse(gir);
        let aux,
            cont = 0;
        for (let index = 0; index < this.giros.length; index++) {
          //Condiciones para poner en optgroup o opction
          //INDPAD -> 1 - Indica que si tiene optgroup con options
          if(this.giros[index].INDPAD === '1') {
            this.datagiros.push({PK_CONSEC: this.giros[index].PK_CONSEC, DESCRI: this.giros[index].DESCRI, ITEMS: []});
            aux = cont;
            cont++;
            //INDPAD -> 2 - Indica que no tiene optgroup solo option
          } else if(this.giros[index].INDPAD === '0'){
            this.datagiros[aux].ITEMS.push(this.giros[index]);
          }
        }
        this.getGradoEstudios();

      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
       }, 500);
      }
      setTimeout(() => {
        if($('#selGir option:selected').text() == '') {
          this.selGiro = '-1';
        }
      }, 100);

    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
          this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
          this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    });
  }

  //Obtiene estratificacion
  getEstratificacion() {
    let tabla = 'FKCPRCO';
    let campo = 'INDESTRA';
    this.apiRegistry.getEstratificacion(tabla, campo).subscribe(data => {
      if (data[0].success) {
        this.estratificacion = data[0].info;
        this.getListaBancos();
      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
       }, 500);
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
          this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
          this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    });
  }

  //Obtiene lista de los bancos
  getListaBancos() {
    let cveLov = 'LOVBANCO';
    this.apiRegistry.getLovs(cveLov).subscribe(data => {
      if (data[0].success) {
        let banc = data[0].info;
        this.bancos = JSON.parse(banc);
        this.getAsentamiento();
      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
       }, 500);
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
          this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
          this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    });
  }

  //Obtiene asentamientos
  getAsentamiento() {
    let tabla = 'FKCPRCO',
        campo = 'INDASEN';
    this.apiRegistry.getIndicadores(tabla, campo).subscribe(data => {
        if (data[0].success) {
          this.asentamiento = data[0].info;
          this.getVialidad();
        } else {
          this.mensajeError = data[0].msgRespuesta;
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
            $('#error').modal('show');
         }, 500);
        }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
          this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
          this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    });
    // if($('#selGir option:selected').text() == '') {
    //   this.selGiro = '-1';
    // }
  }

  //Obtiene vialidad
  getVialidad() {
    let tabla = 'FKCPRCO',
        campo = 'INDVIAL';
    this.apiRegistry.getIndicadores(tabla, campo).subscribe(data => {
        if (data[0].success) {
          this.vialidad = data[0].info;
          this.getRepresentante();
        } else {
          this.mensajeError = data[0].msgRespuesta;
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
            $('#error').modal('show');
         }, 500);
        }
      },
      error => {
        this.error = error.status;
        if (error.status === 401) {
          this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
        } else  {
          this.mensajeError = '¡Error!';
        }
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
       }, 500);
      });
  }

  //Obtiene personalidades del representante
  getRepresentante() {
    let tabla = 'FKCPRCO',
        campo = 'INDPLEG';
    this.apiRegistry.getIndicadores(tabla, campo).subscribe(data => {
        if (data[0].success) {
          this.representantes = data[0].info;
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
         }, 500);
        } else {
          this.mensajeError = data[0].msgRespuesta;
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
            $('#error').modal('show');
         }, 500);
        }
        this.getGiros();
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
          this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
          this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    });
  }

  //Cambia nombre de etiquetas de los representantes segun la personalidas del representante
  cambiaEtiquetas() {
    let represent = this.representantes.filter(a => a.clave == this.selRepresentante);
    this.etiquetrepr = represent[0].descripcion;
  }


  cambioPersona(tipo: string) {
    this.tipoPersona = tipo + this.radioProveedor;
  }

  //Al cambiar tipo de proveedor
  cambioProveedor(event) {
    this.radioProveedor = event.target.value;
    this.tipoPersona = this.tipoPersona.substring(0,1) + this.radioProveedor;
    this.getGiros();
    //console.log('Radio Proveedor: ' + this.tipoPersona);
  }

  //Registro
  registrar(band: boolean) {
    if ( this.validaDatosGenerales(band) && this.validaCampos(band) ) {
      this.errorCamposInc = false;
      this.guardarRegistro(band);
    } else {
      this.errorCamposInc = true;
      window.scroll(0, 0);
    }
  }

  //Cara de datos en los campos
  cargaDatos(datos) {
    this.radioSituacion = datos[0].PK_TIPO_PERSONA;
    if (this.radioSituacion === '') {
      let proveedor: Proveedor;
      proveedor = this.apiAuth.getTokenDecoded();
      //Seleccionar Situacion Fiscal con respescto a su RFC  12 digitos -> MORAL, 13 digitos -> FISICA
      if (proveedor.RFC.length === 12) {
        this.radioSituacion = '2';
      } else if (proveedor.RFC.length === 13) {
        this.radioSituacion = '1';
      }
    }
    let radioSit = this.radioSituacion == '1' ? 'F' : 'M';
    this.radioTipo = datos[0].PK_TIPO_PROVEEDOR == '1' ? 'S' : datos[0].PK_TIPO_PROVEEDOR == '2' ? 'O' :datos[0].PK_TIPO_PROVEEDOR == '3'? 'A':'P';
    this.radioProveedor = this.radioTipo;
    this.tipoPersona = radioSit + this.radioTipo;

    if(datos[0].PK_ESTATUS !== '0' && datos[0].PK_ESTATUS !== '4'){
      this.bloquea = true;
    }else{
      this.bloquea = false;
    }


//------Se mueve seccion
    this.contactForm.controls.correoContacto.setValue(datos[0].CORREO_CONTACTO);
    //this.txtCorreEmpre = datos[0].CORREO_EMP_CONTACTO;
    this.contactForm.controls.correoEmpresa.setValue(datos[0].CORREO_EMP_CONTACTO);

    this.txtCurp = datos[0].CURP_CONTACTO;
    this.txtNombre = datos[0].NOMBRE_CONTACTO;
    this.txtApeMat = datos[0].APEMAT_CONTACTO;
    this.txtApePat = datos[0].APEPAT_CONTACTO;

    this.txtMovil = datos[0].MOVIL_CONTACTO;
    this.txtNumero = datos[0].NUMEXT;
    this.txtInterior = datos[0].NUMINT;
    this.txtNumTel1 = datos[0].TELEFONO;
    this.selBanco = datos[0].PK_BANCO;
//------Se mueve seccion

    if (this.tipoPersona === 'MS') {
      this.txtObjetoSocial = datos[0].ACTIVIDAD_EMP;
      this.txtRepreLeg = datos[0].NOMBRE_RLEGAL;
      this.txtApePatRepreLeg = datos[0].APEPAT_RLEGAL;
      this.txtApeMatRepreLeg = datos[0].APEMAT_RLEGAL;
      //this.txtCurpRepLegal = datos[0].CURP_RLEGAL;
      this.contactForm.controls.curpRl.setValue(datos[0].CURP_RLEGAL);
      //this.correoRl = datos[0].CORREO_RLEGAL;
      this.contactForm.controls.correoRl.setValue(datos[0].CORREO_RLEGAL);
      this.telefonoRl = datos[0].TELEFONO_RLEGAL;
      this.telcelRl = datos[0].TELCEL_RLEGAL;
      this.selEstratificacion = datos[0].ESTRATIFICA;
      this.selGiro = datos[0].PK_GIRO;
      this.txtNombreComercial = datos[0].NOMBRE_COM;
      this.txtRazonSocial = datos[0].RAZSOC;
      this.selRepresentante = datos[0].INDPLEG;
    } else if (this.tipoPersona === 'MO' || this.tipoPersona === 'MA') {
      this.txtObjetoSocial = datos[0].ACTIVIDAD_EMP;
      this.txtRepreLeg = datos[0].NOMBRE_RLEGAL;
      this.txtApePatRepreLeg = datos[0].APEPAT_RLEGAL;
      this.txtApeMatRepreLeg = datos[0].APEMAT_RLEGAL;
      //this.txtCurpRepLegal = datos[0].CURP_RLEGAL;
      this.contactForm.controls.curpRl.setValue(datos[0].CURP_RLEGAL);
      //this.correoRl = datos[0].CORREO_RLEGAL;
      this.contactForm.controls.correoRl.setValue(datos[0].CORREO_RLEGAL);
      this.telefonoRl = datos[0].TELEFONO_RLEGAL;
      this.telcelRl = datos[0].TELCEL_RLEGAL;
      this.selEstratificacion = datos[0].ESTRATIFICA;
      this.selGiro = datos[0].PK_GIRO;
      this.txtNombreComercial = datos[0].NOMBRE_COM;
      this.txtRazonSocial = datos[0].RAZSOC;
      this.selRepresentante = datos[0].INDPLEG;
      this.txtNoCeduPadr = datos[0].CEDULA;
      //this.txtCurpRepTec = datos[0].CURP_RTECNICO;
      this.contactForm.controls.curpRt.setValue(datos[0].CURP_RTECNICO);
      this.txtRepreTec = datos[0].NOMBRE_RTECNICO;
      this.txtApePatRepreTec = datos[0].APEPAT_RTECNICO;
      this.txtApeMatRepreTec = datos[0].APEMAT_RTECNICO;
      // this.correoRt = datos[0].CORREO_RTECNICO;
      this.contactForm.controls.correoRt.setValue(datos[0].CORREO_RTECNICO);
      this.telefonoRt = datos[0].TELEFONO_RTECNICO;
      this.telcelRt = datos[0].TELCEL_RTECNICO;
    } else if (this.tipoPersona === 'FS') {
      // this.txtCurpF = datos[0].CURP;
      this.contactForm.controls.curp.setValue(datos[0].CURP);
      this.txtNombreF = datos[0].NOMBRE_PF;
      this.txtApePatF = datos[0].APEPAT_PF;
      this.txtApeMatF = datos[0].APEMAT_PF;
      this.selGiro = datos[0].PK_GIRO;
      this.txtActiEmp = datos[0].ACTIVIDAD_EMP;
    } else if (this.tipoPersona === 'FO' || this.tipoPersona === 'FA') {
      // this.txtCurpF = datos[0].CURP;
      this.contactForm.controls.curp.setValue(datos[0].CURP);
      this.txtNombreF = datos[0].NOMBRE_PF;
      this.txtApePatF = datos[0].APEPAT_PF;
      this.txtApeMatF = datos[0].APEMAT_PF;
      this.selGiro = datos[0].PK_GIRO;
      this.txtActiEmp = datos[0].ACTIVIDAD_EMP;
      this.txtNoCeduPadrF = datos[0].CEDULA;
      //Representante tecnico
      this.contactForm.controls.curpRt.setValue(datos[0].CURP_RTECNICO);
      this.txtRepreTec = datos[0].NOMBRE_RTECNICO;
      this.txtApePatRepreTec = datos[0].APEPAT_RTECNICO;
      this.txtApeMatRepreTec = datos[0].APEMAT_RTECNICO;
      this.contactForm.controls.correoRt.setValue(datos[0].CORREO_RTECNICO);
      this.telefonoRt = datos[0].TELEFONO_RTECNICO;
      this.telcelRt = datos[0].TELCEL_RTECNICO;
    }else if (this.tipoPersona === 'FP') {
      // this.txtCurpF = datos[0].CURP;
      this.contactForm.controls.curp.setValue(datos[0].CURP);
      //13/09/2022 ASOLEDAD
      this.txtNombreF = datos[0].NOMBRE_PF;
      this.txtApePatF = datos[0].APEPAT_PF;
      this.txtApeMatF = datos[0].APEMAT_PF;
      //this.selGiro = datos[0].PK_GIRO;
      this.selGiro = '0';
      this.txtActiEmp = datos[0].ACTIVIDAD_EMP;

      //this.contactForm.controls.txtCurp.setValue(datos[0].CURP);

      this.txtNombre = datos[0].NOMBRE_PF;
      this.txtApeMat = datos[0].APEPAT_PF;
      this.txtApePat = datos[0].APEMAT_PF;

      this.selNivel  = datos[0].GRADEST;
      this.txtNumCedula = datos[0].NUMCED;
      this.getPaisesDatGen(datos[0].PAISNAC,datos[0].ESTADO,datos[0].MUNICIPIO);
      this.selPais = datos[0].PAISNAC;

      //this.getEstados(datos[0].PAISNAC,datos[0].ESTADO);
      this.selEstados = datos[0].ESTADO;

      //this.getCiudades(datos[0].ESTADO,datos[0].MUNICIPIO);

      this.selCiud    = datos[0].MUNICIPIO;
      this.radioSexo = datos[0].SEXO;
      this.fechaNacimiento = datos[0].FECNAC;
      this.ciudDescri = datos[0].CIUDAD;


    }

    this.subcontratacion = datos[0].SUBCONTRATA;
    //Carga datos de domicilio fiscal, contacto y datos bancarios.
    this.txtTelef = datos[0].TELEFONO_CONTACTO;
    this.fcccuba = datos[0].PK_FCCCUBA;
    this.fkcprco = datos[0].PK_FKCPRCO;
    this.fkcpers = datos[0].PK_FKCPERS;
    this.fkcpersRl = datos[0].PK_FKCPERS_RLEGAL;
    this.fkcpersRt = datos[0].PK_FKCPERS_RTECNICO;
    this.fkcpersCt = datos[0].PK_FKCPERS_CONTACTO;
    this.txtCalle = datos[0].CALLE;
    this.selVialidad = datos[0].INDVIAL;
    //this.selAsentamiento = datos[0].INDASEN;
    this.txtPaginaWeb = datos[0].PAGWEB;
    this.txtCuentaClabe = datos[0].CLABE;
    //this.txtCorreElec = datos[0].CORREO_CONTACTO;

    this.txtCP = datos[0].CP;
    // this.cargaLocalidad();
    this.cargaLocalidad(datos[0].PK_ESTADO, datos[0].PK_MUNICIPIO, datos[0].PK_COLONIA);
    this.txtCuenta = datos[0].CUENTA;

    // this.selEstado = datos[0].PK_ESTADO;
    // this.selCiudadMuni = datos[0].PK_MUNICIPIO;
    // this.selColonia = datos[0].PK_COLONIA;

  }

  //Carga las localidades
  cargaLocalidad(estado, municipio, colonia) {
    //console.log("cP: "+this.txtCP.length);
    if (this.txtCP.toString().length > 0) {
      //console.log("cP: "+this.txtCP);
      this.apiRegistry.getCodigoPostal(this.txtCP).subscribe(data => {
        if (data[0].success) {
          let informac = data[0].info;
          informac = JSON.parse(informac);
          //console.log("Datos: "+informac);
          if(informac.length > 1) {
            this.estados.push({nombre: informac[1].DESCRIEST, idEstado: informac[1].CVEEDO});
            this.municipios.push({nombre: informac[1].DESCRIMUN, idMunicipio: informac[1].CLAVEMUN});
            this.colonias = informac;
            this.selEstado = estado;
            this.selCiudadMuni = municipio;
            this.selColonia = colonia;
            let asent = this.colonias.filter(a => a.CVECOL == this.selColonia);
            this.selAsentamiento = asent[0].DESCRIASEN;
          }
        }
      });
    }

  }

  //Llamada al WS para guarda el registro
  guardarRegistro(bandera: boolean) {
    let proveedor: Proveedor;
    proveedor = this.apiAuth.getTokenDecoded();
    $('#mod_procesando').modal('show');
    this.limpiaCampos();
    //Se tendra que llamar al servicio de guardado de los datos
    let nocedula = this.tipoPersona.substring(0,1) == 'M' ? this.txtNoCeduPadr : this.txtNoCeduPadrF;
    let objSocial = this.tipoPersona.substring(0,1) == 'M' ? this.txtObjetoSocial : this.radioProveedor !== 'P'? this.txtActiEmp:"PRESTADOR DE SERVICIO";
    let sitfiscal = this.tipoPersona.substring(0,1) == 'M' ? 2 : 1;
    let tipoProv = this.radioProveedor == 'S' ? 1 : this.radioProveedor == 'O' ? 2 :this.radioProveedor == 'A' ? 3:4;


    let datosGen =
    {
        indfis: sitfiscal,
        indtip: tipoProv,
        nombcom: this.txtNombreComercial.toUpperCase(),
        razsoc: this.txtRazonSocial.toUpperCase(),
        giro: this.selGiro,
        estratifi: this.selEstratificacion,
        noCedPadEst: nocedula,
        pk_fkcpers: this.fkcpers,
        curp: this.txtCurpF.toUpperCase(),
        nombre: this.txtNombreF.toUpperCase(),
        apepat: this.txtApePatF.toUpperCase(),
        apemat: this.txtApeMatF.toUpperCase(),
        activEmp: objSocial.toUpperCase(),
        folio: this.fkcprco,
        rfc: proveedor.RFC,
        subcontrat: this.subcontratacion,
        representante: this.selRepresentante
      , gradoEstudio : this.selNivel
      , cedula: this.txtNumCedula

      , pais : this.selPais
      , estado : this.selEstados
      , ciudad : this.selCiud
      , fechaNac : this.fechaNacimiento
      , sexo : this.radioSexo
      , ciudadDesc : this.ciudDescri
      };

    let representantes =
    {
        pk_fkcpers_rl: this.fkcpersRl,
        curpReprLegal: this.txtCurpRepLegal.toUpperCase(),
        nomReprLegal: this.txtRepreLeg.toUpperCase(),
        apepatReprL: this.txtApePatRepreLeg.toUpperCase(),
        apematReprL: this.txtApeMatRepreLeg.toUpperCase(),
        telefono_rl: this.telefonoRl,
        telcel_rl: this.telcelRl,
        correo_rl: this.correoRl,
        pk_fkcpers_rt: this.fkcpersRt,
        curpReprTec: this.txtCurpRepTec.toUpperCase(),
        nomReprTec: this.txtRepreTec.toUpperCase(),
        apepatReprT: this.txtApePatRepreTec.toUpperCase(),
        apematReprT: this.txtApeMatRepreTec.toUpperCase(),
        telefono_rt: this.telefonoRt,
        telcel_rt: this.telcelRt,
        correo_rt: this.correoRt
    };

    let domicilioFis =
    {
        calle: this.txtCalle.toUpperCase(),
        numeroExt: this.txtNumero,
        numeroInt: this.txtInterior,
        cp: this.txtCP,
        colonia: this.selColonia,
        ciudMuni: this.selCiudadMuni,
        estado: this.selEstado,
        tel1: this.txtNumTel1,
        vialidad: this.selVialidad
    };

    let contacto =
    {
        pk_fkcpers_ct: this.fkcpersCt,
        curp: this.txtCurp.toUpperCase(),
        nombre: this.txtNombre.toUpperCase(),
        apepat: this.txtApePat.toUpperCase(),
        apemat: this.txtApeMat.toUpperCase(),
        correo: this.txtCorreElec,
        telef: this.txtTelef,
        movil: this.txtMovil,
        correoEmp: this.txtCorreEmpre,
        paginaweb: this.txtPaginaWeb
    };

    let datosBanco =
    {
        fcccuba: this.fcccuba,
        banco: this.selBanco,
        cuenta: this.txtCuenta,
        cuentaClabe: this.txtCuentaClabe
    };
    this.apiRegistry.registro(datosGen, representantes, domicilioFis, contacto, datosBanco).subscribe(data => {
                                if (data[0].success) {
                                  this.fcccuba = data[0].info.fcccuba;
                                  this.fkcprco = data[0].info.pk_prov;
                                  this.fkcpers = data[0].info.fkcpers;
                                  this.fkcpersRl = data[0].info.fkcpers_rl;
                                  this.fkcpersRt = data[0].info.fkcpers_rt;
                                  this.fkcpersCt = data[0].info.fkcpers_ct;
                                  if (this.etiquetCveProv === '') {
                                      this.etiquetCveProv = this.fkcprco;
                                  }
                                    setTimeout(() => {
                                      $('#mod_procesando').modal('hide');
                                      if(bandera){
                                        $('#success_exito').modal('show');
                                      } else {
                                        $('#success').modal('show');
                                      }
                                    },500);
                                  } else {
                                    this.mensajeError = data[0].msgRespuesta;
                                    setTimeout(() => {
                                      $('#mod_procesando').modal('hide');
                                      $('#error').modal('show');
                                   }, 500);
                                  }
                                },
                                error => {
                                  console.error('Error');
                                  this.error = error.status;
                                  if (error.status === 401) {
                                      this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
                                  } else  {
                                      this.mensajeError = '¡Error!';
                                  }
                                  setTimeout(() => {
                                    $('#mod_procesando').modal('hide');
                                    $('#error').modal('show');
                                  },500);
                                });
  }

  siguiente() {
    this.router.navigate(['/registro-docsarch']);
  }


  cambio() {
    let asent = this.colonias.filter(a => a.CVECOL == this.selColonia);
    this.selAsentamiento = asent[0].DESCRIASEN;
  }

  //Checa codigo postal para traer el municipio y estado
  checaCp() {
    if (this.txtCP.length > 0) {
      this.spinn = 'uaa-w-87';
      this.spinner = '';
      this.disabledCp = false;
      this.apiRegistry.getCodigoPostal(this.txtCP).subscribe(data => {
        if (data[0].success) {
          this.spinn = '';
          this.spinner = 'uaa-none';
          this.disabledCp = true;
          let informac = data[0].info;
          informac = JSON.parse(informac);

          if(informac.length > 1) {
              this.estados = [];
              this.municipios = [];
              this.colonias = [];
              this.estados.push({nombre: informac[1].DESCRIEST, idEstado: informac[1].CVEEDO});
              this.municipios.push({nombre: informac[1].DESCRIMUN, idMunicipio: informac[1].CLAVEMUN});
              this.colonias = informac;
              this.selEstado = this.estados[0].idEstado;
              this.selCiudadMuni = this.municipios[0].idMunicipio;
              // $("#selectColonia option[value='-1']").remove();
              this.selColonia = '0';
          } else {
              this.selEstado = '-1';
              this.selCiudadMuni = '-1';
              this.municipios = [];
              this.colonias = [];
          }
        } else {
          this.spinn = '';
          this.spinner = 'uaa-none';
          this.disabledCp = true;
        }
      });
    } else {
      this.selEstado = '-1';
      this.selCiudadMuni = '-1';
      this.municipios = [];
      this.colonias = [];
    }
  }

  //Validaciones para la seccion de datos generales
  validaDatosGenerales(band: boolean) {
    let bandValida = true;


    if (this.tipoPersona === 'MS') {
        if (this.txtRazonSocial === '') {
            this.razonSocial = 'is-invalid';
            bandValida = false;
        } else {
          this.razonSocial = '';
        }
        if (this.txtNombreComercial === '') {
            this.nombreComercial = 'is-invalid';
            bandValida = false;
        } else {
          this.nombreComercial = '';
        }

        if (this.selGiro === '-1') {
          this.giro = 'is-invalid';
          bandValida = false;
        } else {
          this.giro = '';
        }

        if (this.selEstratificacion === '-1') {
          this.estrati = 'is-invalid';
          bandValida = false;
        } else {
          this.estrati = '';
        }


        if (this.txtObjetoSocial === '') {
          this.objetoSocial = 'is-invalid';
          bandValida = false;
        } else {
          this.objetoSocial = '';
        }

        this.contactForm.controls.curpRl.setValue(this.contactForm.get('curpRl').value.toUpperCase());
        if (this.contactForm.controls.curpRl.hasError('required')) {
          bandValida = false;
          this.curpRepLegal = 'is-invalid';
          this.errorCurpRl = '';
        } else if (this.contactForm.controls.curpRl.hasError('pattern')) {
          bandValida = false;
          this.curpRepLegal = 'is-invalid';
          this.errorCurpRl = 'Formato Curp incorrecto';
        } else {
          this.errorCurpRl = '';
          this.curpRepLegal = '';
          this.txtCurpRepLegal = this.contactForm.get('curpRl').value;
        }
        // if (this.txtCurpRepLegal === '') {
        //   this.curpRepLegal = 'is-invalid';
        //   bandValida = false;
        // } else {
        //   this.curpRepLegal = '';
        // }

        if (this.txtRepreLeg === '') {
          this.repreLeg = 'is-invalid';
          bandValida = false;
        } else {
          this.repreLeg = '';
        }

        if (this.telefonoRl === '') {
          this.telefonoRepL = 'is-invalid';
          bandValida = false;
        } else {
          this.telefonoRepL = '';
        }

        if (this.telcelRl === '') {
          this.telcelRepL = 'is-invalid';
          bandValida = false;
        } else {
          this.telcelRepL = '';
        }


        if (this.contactForm.controls.correoRl.hasError('required')) {
          bandValida = false;
          this.correoRepL = 'is-invalid';
          this.errorCorreoRl = '';
        } else if (this.contactForm.controls.correoRl.hasError('pattern')) {
          bandValida = false;
          this.correoRepL = 'is-invalid';
          this.errorCorreoRl = 'Formato Correo incorrecto';
        } else {
          this.errorCorreoRl = '';
          this.correoRepL = '';
          this.correoRl = this.contactForm.get('correoRl').value;
        }
        // if (this.correoRl === '') {
        //   this.correoRepL = 'is-invalid';
        //   bandValida = false;
        // } else {
        //   this.correoRepL = '';
        // }

        if (band) {
          if (this.txtApePatRepreLeg === '') {
            this.apePatRepreLeg = 'is-invalid';
            bandValida = false;
          } else {
            this.apePatRepreLeg = '';
          }

          if (this.txtApeMatRepreLeg === '') {
            this.apeMatRepreLeg = 'is-invalid';
            bandValida = false;
          } else {
            this.apeMatRepreLeg = '';
          }
        }
    } else if (this.tipoPersona === 'MO' || this.tipoPersona === 'MA') {
              if (this.txtRazonSocial === '') {
                this.razonSocial = 'is-invalid';
                bandValida = false;
              } else {
                this.razonSocial = '';
              }

              if (this.txtNoCeduPadr === '') {
                this.noCeduPadr = 'is-invalid';
                bandValida = false;
              } else {
                this.noCeduPadr = '';
              }

              if (this.txtRepreLeg === '') {
                this.repreLeg = 'is-invalid';
                bandValida = false;
              } else {
                this.repreLeg = '';
              }

              if (this.selGiro === '-1') {
                this.giro = 'is-invalid';
                bandValida = false;
              } else {
                this.giro = '';
              }

              if (this.selEstratificacion === '-1') {
                this.estrati = 'is-invalid';
                bandValida = false;
              } else {
                this.estrati = '';
              }

              this.contactForm.controls.curpRt.setValue(this.contactForm.get('curpRt').value.toUpperCase());
              if (this.contactForm.controls.curpRt.hasError('required')) {
                bandValida = false;
                this.curpRepTec = 'is-invalid';
                this.errorCurpRt = '';
              } else if (this.contactForm.controls.curpRt.hasError('pattern')) {
                bandValida = false;
                this.curpRepTec = 'is-invalid';
                this.errorCurpRt = 'Formato Curp incorrecto';
              } else {
                this.errorCurpRt = '';
                this.curpRepTec = '';
                this.txtCurpRepTec = this.contactForm.get('curpRt').value;
              }
              // if (this.txtCurpRepTec === '') {
              //   this.curpRepTec = 'is-invalid';
              //   bandValida = false;
              // } else {
              //   this.curpRepTec = '';
              // }

              if (this.txtNombreComercial === '') {
                this.nombreComercial = 'is-invalid';
                bandValida = false;
              } else {
                this.nombreComercial = '';
              }

              if (this.txtObjetoSocial === '') {
                this.objetoSocial = 'is-invalid';
                bandValida = false;
              } else {
                this.objetoSocial = '';
              }

              this.contactForm.controls.curpRl.setValue(this.contactForm.get('curpRl').value.toUpperCase());
              if (this.contactForm.controls.curpRl.hasError('required')) {
                bandValida = false;
                this.curpRepLegal = 'is-invalid';
                this.errorCurpRl = '';
              } else if (this.contactForm.controls.curpRl.hasError('pattern')) {
                bandValida = false;
                this.curpRepLegal = 'is-invalid';
                this.errorCurpRl = 'Formato Curp incorrecto';
              } else {
                this.errorCurpRl = '';
                this.curpRepLegal = '';
                this.txtCurpRepLegal = this.contactForm.get('curpRl').value;
              }
              // if (this.txtCurpRepLegal === '') {
              //   this.curpRepLegal = 'is-invalid';
              //   bandValida = false;
              // } else {
              //   this.curpRepLegal = '';
              // }

              if (this.txtRepreTec === '') {
                this.repreTec = 'is-invalid';
                bandValida = false;
              } else {
                this.repreTec = '';
              }

              if (this.telefonoRl === '') {
                this.telefonoRepL = 'is-invalid';
                bandValida = false;
              } else {
                this.telefonoRepL = '';
              }

              if (this.telcelRl === '') {
                this.telcelRepL = 'is-invalid';
                bandValida = false;
              } else {
                this.telcelRepL = '';
              }


              if (this.contactForm.controls.correoRl.hasError('required')) {
                bandValida = false;
                this.correoRepL = 'is-invalid';
                this.errorCorreoRl = '';
              } else if (this.contactForm.controls.correoRl.hasError('pattern')) {
                bandValida = false;
                this.correoRepL = 'is-invalid';
                this.errorCorreoRl = 'Formato Correo incorrecto';
              } else {
                this.errorCorreoRl = '';
                this.correoRepL = '';
                this.correoRl = this.contactForm.get('correoRl').value;
              }
              // if (this.correoRl === '') {
              //   this.correoRepL = 'is-invalid';
              //   bandValida = false;
              // } else {
              //   this.correoRepL = '';
              // }


              if (this.telefonoRt === '') {
                this.telefonoRepT = 'is-invalid';
                bandValida = false;
              } else {
                this.telefonoRepT = '';
              }

              if (this.telcelRt === '') {
                this.telcelRepT = 'is-invalid';
                bandValida = false;
              } else {
                this.telcelRepT = '';
              }


              if (this.contactForm.controls.correoRt.hasError('required')) {
                bandValida = false;
                this.correoRepT = 'is-invalid';
                this.errorCorreoRt = '';
              } else if (this.contactForm.controls.correoRt.hasError('pattern')) {
                bandValida = false;
                this.correoRepT = 'is-invalid';
                this.errorCorreoRt = 'Formato Correo incorrecto';
              } else {
                this.errorCorreoRt = '';
                this.correoRepT = '';
                this.correoRt = this.contactForm.get('correoRt').value;
              }
              // if (this.correoRt === '') {
              //   this.correoRepT = 'is-invalid';
              //   bandValida = false;
              // } else {
              //   this.correoRepT = '';
              // }

              if (band) {
                if (this.txtApePatRepreLeg === '') {
                  this.apePatRepreLeg = 'is-invalid';
                  bandValida = false;
                } else {
                  this.apePatRepreLeg = '';
                }

                if (this.txtApeMatRepreLeg === '') {
                  this.apeMatRepreLeg = 'is-invalid';
                  bandValida = false;
                } else {
                  this.apeMatRepreLeg = '';
                }

                if (this.txtApePatRepreTec === '') {
                  this.apePatRepreTec = 'is-invalid';
                  bandValida = false;
                } else {
                  this.apePatRepreTec = '';
                }

                if (this.txtApeMatRepreTec === '') {
                  this.apeMatRepreTec = 'is-invalid';
                  bandValida = false;
                } else {
                  this.apeMatRepreTec = '';
                }
              }
    } else if (this.tipoPersona === 'FS') {
              if (this.txtNombreF === '') {
                  this.nombreF = 'is-invalid';
                  bandValida = false;
              } else {
                this.nombreF = '';
              }

              if (this.txtApePatF === '') {
                  this.apePatF = 'is-invalid';
                  bandValida = false;
              } else {
                this.apePatF = '';
              }

              if (this.txtApeMatF === '') {
                  this.apeMatF = 'is-invalid';
                  bandValida = false;
              } else {
                this.apeMatF = '';
              }

              if (this.selGiro === '-1') {
                this.giro = 'is-invalid';
                bandValida = false;
              } else {
                this.giro = '';
              }

              this.contactForm.controls.curp.setValue(this.contactForm.get('curp').value.toUpperCase());
              if (this.contactForm.controls.curp.hasError('required')) {
                bandValida = false;
                this.curpF = 'is-invalid';
                this.errorCurp = '';
              } else if (this.contactForm.controls.curp.hasError('pattern')) {
                bandValida = false;
                this.curpF = 'is-invalid';
                this.errorCurp = 'Formato Curp incorrecto';
              } else {
                this.errorCurp = '';
                this.curpF = '';
                this.txtCurpF = this.contactForm.get('curp').value;
              }
              // if (this.txtCurpF === '') {
              //     this.curpF = 'is-invalid';
              //     bandValida = false;
              // } else {
              //   this.curpF = '';
              // }

              if (this.txtActiEmp === '') {
                  this.actiEmp = 'is-invalid';
                  bandValida = false;
              } else {
                this.actiEmp = '';
              }
    } else if (this.tipoPersona === 'FO' || this.tipoPersona === 'FA') {
              if (this.txtNombreF === '') {
                this.nombreF = 'is-invalid';
                bandValida = false;
              } else {
                this.nombreF = '';
              }

              if (this.txtApePatF === '') {
                  this.apePatF = 'is-invalid';
                  bandValida = false;
              } else {
                this.apePatF = '';
              }

              if (this.txtApeMatF === '') {
                  this.apeMatF = 'is-invalid';
                  bandValida = false;
              } else {
                this.apeMatF = '';
              }

              if (this.selGiro === '-1') {
                this.giro = 'is-invalid';
                bandValida = false;
              } else {
                this.giro = '';
              }

              //Representante tecnico
              this.contactForm.controls.curpRt.setValue(this.contactForm.get('curpRt').value.toUpperCase());
              if (this.contactForm.controls.curpRt.hasError('required')) {
                bandValida = false;
                this.curpRepTec = 'is-invalid';
                this.errorCurpRt = '';
              } else if (this.contactForm.controls.curpRt.hasError('pattern')) {
                bandValida = false;
                this.curpRepTec = 'is-invalid';
                this.errorCurpRt = 'Formato Curp incorrecto';
              } else {
                this.errorCurpRt = '';
                this.curpRepTec = '';
                this.txtCurpRepTec = this.contactForm.get('curpRt').value;
              }

              if (this.txtRepreTec === '') {
                this.repreTec = 'is-invalid';
                bandValida = false;
              } else {
                this.repreTec = '';
              }

              if (this.telefonoRt === '') {
                this.telefonoRepT = 'is-invalid';
                bandValida = false;
              } else {
                this.telefonoRepT = '';
              }

              if (this.telcelRt === '') {
                this.telcelRepT = 'is-invalid';
                bandValida = false;
              } else {
                this.telcelRepT = '';
              }

              if (this.contactForm.controls.correoRt.hasError('required')) {
                bandValida = false;
                this.correoRepT = 'is-invalid';
                this.errorCorreoRt = '';
              } else if (this.contactForm.controls.correoRt.hasError('pattern')) {
                bandValida = false;
                this.correoRepT = 'is-invalid';
                this.errorCorreoRt = 'Formato Correo incorrecto';
              } else {
                this.errorCorreoRt = '';
                this.correoRepT = '';
                this.correoRt = this.contactForm.get('correoRt').value;
              }

              if (band) {
                if (this.txtApePatRepreTec === '') {
                  this.apePatRepreTec = 'is-invalid';
                  bandValida = false;
                } else {
                  this.apePatRepreTec = '';
                }

                if (this.txtApeMatRepreTec === '') {
                  this.apeMatRepreTec = 'is-invalid';
                  bandValida = false;
                } else {
                  this.apeMatRepreTec = '';
                }
              }


              this.contactForm.controls.curp.setValue(this.contactForm.get('curp').value.toUpperCase());
              if (this.contactForm.controls.curp.hasError('required')) {
                bandValida = false;
                this.curpF = 'is-invalid';
                this.errorCurp = '';
              } else if (this.contactForm.controls.curp.hasError('pattern')) {
                bandValida = false;
                this.curpF = 'is-invalid';
                this.errorCurp = 'Formato Curp incorrecto';
              } else {
                this.errorCurp = '';
                this.curpF = '';
                this.txtCurpF = this.contactForm.get('curp').value;
              }
              // if (this.txtCurpF === '') {
              //     this.curpF = 'is-invalid';
              //     bandValida = false;
              // } else {
              //   this.curpF = '';
              // }

              if (this.txtActiEmp === '') {
                  this.actiEmp = 'is-invalid';
                  bandValida = false;
              } else {
                this.actiEmp = '';
              }

              if (this.txtNoCeduPadrF === '') {
                  this.noCeduPadrF = 'is-invalid';
                  bandValida = false;
              } else {
                this.noCeduPadrF = '';
              }
    }else if (this.tipoPersona === 'FP') {
      if (this.txtNombreF === '') {
        this.nombreF = 'is-invalid';
        bandValida = false;
      } else {
        this.nombreF = '';
      }

      if (this.txtApePatF === '' && this.txtApeMatF === '') {
          this.apePatF = 'is-invalid';
          this.apeMatF = 'is-invalid';
          bandValida = false;
      } else {
        this.apePatF = '';
        this.apeMatF = '';
      }

      /*if (this.txtApeMatF === '') {
          this.apeMatF = 'is-invalid';
          bandValida = false;
      } else {
        this.apeMatF = '';
      }*/

      if (this.selNivel === '-1') {
          this.grado = 'is-invalid';
          bandValida = false;
      } else {
          this.grado = '';
      }

      console.log("FechaNac: "+this.fechaNacimiento);
      //asoledad: 26/05/2022
      if (this.fechaNacimiento === '') {
        this.classfechaNac = 'is-invalid';
        bandValida = false;
      } else {
          this.classfechaNac = '';
      }

      //asoledad: 26/05/2022
      if (this.selPais === '-1') {
        this.classPais = 'is-invalid';
        bandValida = false;
      } else {
          this.classPais = '';
      }

      //asoledad: 26/05/2022
      if (this.selEstados === '-1') {
        this.classEdo = 'is-invalid';
        bandValida = false;
      } else {
          this.classEdo = '';
      }

      //asoledad: 26/05/2022
      if (this.selCiud === '-1' && this.ciudDescri === '') {
        this.classCiud = 'is-invalid';
        bandValida = false;
      } else {
          this.classCiud = '';
      }

      //asoledad: 24/05/2022
      if (this.txtNumCedula === '' && !this.ocultaCed) {
        this.numcedula = 'is-invalid';
        bandValida = false;
      } else {
          this.numcedula = '';
      }

      this.contactForm.controls.curp.setValue(this.contactForm.get('curp').value.toUpperCase());
      if (this.contactForm.controls.curp.hasError('required')) {
        bandValida = false;
        this.curpF = 'is-invalid';
        this.errorCurp = '';
      } else if (this.contactForm.controls.curp.hasError('pattern')) {
        bandValida = false;
        this.curpF = 'is-invalid';
        this.errorCurp = 'Formato Curp incorrecto';
      } else {
        this.errorCurp = '';
        this.curpF = '';
        this.txtCurpF = this.contactForm.get('curp').value;
      }

}

    return bandValida;
  }


  //Validacion de campos
  validaCampos(band: boolean) {
    let bandValida = true;
    if ( this.txtCalle === '' ) {
        this.calle = 'is-invalid';
        bandValida = false;
    } else {
      this.calle = '';
    }

    if ( this.txtNumero === '' ) {
      this.numero = 'is-invalid';
      bandValida = false;
    } else {
      this.numero = '';
    }

    if ( this.txtCP === '' ) {
      this.cp = 'is-invalid';
      bandValida = false;
    } else {
      this.cp = '';
    }

    if (this.selColonia === '0' || this.selColonia === '-1' || this.selColonia === '') {
      this.colon = 'is-invalid';
      bandValida = false;
    } else {
      this.colon = '';
    }

    if (this.selVialidad === '-1') {
      this.vialidadClass = 'is-invalid';
      bandValida = false;
    } else {
      this.vialidadClass = '';
    }

    if (band && this.tipoPersona !== 'FP') {

    if ( this.txtNumTel1 === '') {
      this.numtel1 = 'is-invalid';
      bandValida = false;
    } else {
      this.numtel1 = '';
    }

    if ( this.txtCurp === '') {
      this.curp = 'is-invalid';
      bandValida = false;
    } else {
      this.curp = '';
    }


    if ( this.txtNombre === '') {
      this.nombre = 'is-invalid';
      bandValida = false;
    } else {
      this.nombre = '';
    }
    //Si band es true, esta realizando registro de continuar
      if ( this.txtApePat === '' ) {
        this.apePat = 'is-invalid';
        bandValida = false;
      } else {
        this.apePat = '';
      }

      if ( this.txtApeMat === '' ) {
        this.apeMat = 'is-invalid';
        bandValida = false;
      } else {
        this.apeMat = '';
      }
    }

    if (this.contactForm.controls.correoContacto.hasError('required')) {
      bandValida = false;
      this.correElec = 'is-invalid';
      this.errorCorreo = '';
    } else if (this.contactForm.controls.correoContacto.hasError('pattern')) {
      bandValida = false;
      this.correElec = 'is-invalid';
      this.errorCorreo = 'Formato Correo incorrecto';
    } else {
      this.errorCorreo = '';
      this.correElec = '';
      this.txtCorreElec = this.contactForm.get('correoContacto').value;
    }

    // if ( this.txtCorreElec === '' ) {
    //   this.correElec = 'is-invalid';
    //   bandValida = false;
    // } else {
    //   this.correElec = '';
    // }

    if ( this.txtTelef === '' ) {
      this.telef = 'is-invalid';
      bandValida = false;
    } else {
      this.telef = '';
    }

    if ( this.txtMovil === '' ) {
      this.movil = 'is-invalid';
      bandValida = false;
    } else {
      this.movil = '';
    }

    if(this.tipoPersona!=='FP'){
      if (this.contactForm.controls.correoEmpresa.hasError('required')) {
        bandValida = false;
        this.correEmpre = 'is-invalid';
        this.errorCorreoEmp = '';
      } else if (this.contactForm.controls.correoEmpresa.hasError('pattern')) {
        bandValida = false;
        this.correEmpre = 'is-invalid';
        this.errorCorreoEmp = 'Formato Correo incorrecto';
      } else {
        this.errorCorreoEmp = '';
        this.correEmpre = '';
        this.txtCorreEmpre = this.contactForm.get('correoEmpresa').value;
      }
    }

    // if ( this.txtCorreEmpre === '' ) {
    //   this.correEmpre = 'is-invalid';
    //   bandValida = false;
    // } else {
    //   this.correEmpre = '';
    // }

    if (this.selBanco === '-1') {
      this.banc = 'is-invalid';
      bandValida = false;
    } else {
      this.banc = '';
    }

    if ( this.txtCuenta === '' || this.txtCuenta.length < 10) {
      this.cuenta = 'is-invalid';
      bandValida = false;
      this.errorCuenta = 'La longitud de la Cuenta Bancaria es incorrecto';
    } else {
      this.cuenta = '';
      this.errorCuenta = '';
    }

    if ( this.txtCuentaClabe === '' || this.txtCuentaClabe.length < 18) {
      this.cuentaClabe = 'is-invalid';
      bandValida = false;
      this.errorCLABE = 'La longitud de la Cuenta CLABE es incorrecto';
    } else {
      this.cuentaClabe = '';
      this.errorCLABE = '';
    }

    return bandValida;
  }

  //Validacion solo numeros
  checa(evento) {

    let tecla = (document.all) ? evento.keyCode : evento.which;

    if (tecla == 8) {
      return true;
    }

    let patron = /[0-9]/;

    let tecla_final = String.fromCharCode(tecla);

    return patron.test(tecla_final);

  }

  //Validaciones quita caracteres especiales
  reemplazaCaracter(evento) {
    let cadena = evento.target.value;
    let regex = /^[a-zA-Z]+(\s*[a-zA-Z]*)*[a-zA-Z]+$/g;
    //  /^[a-zA-Z]+(\s*[a-zA-Z]*)*[a-zA-Z]+$/;
    //cadena = cadena.replace(/["#'$()%!?=+{}¿&/\\]/g, '');
    evento.target.value = cadena.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  //Buscar si la curp ya ha sido registrada anteriormente para traer la información
  buscaCurp(evento, curp) {
    let cadena = evento.target.value;
    cadena = cadena.replace(/["/\\]/g, '');
    evento.target.value = cadena;
    //Llamada para checar si la persona ya estar registrada en la BD
    if( cadena.length > 0 ) {
        this.apiRegistry.getPersonaCurp(cadena).subscribe(data => {
          if(data[0].success) {
            let infor = data[0].info;
            if(infor !== '{}') {
                infor = JSON.parse(infor);
                //Curp que pertenece a Contacto
                if (curp === 'C') {
                    this.txtNombre = infor[0].NOMBRE;
                    this.txtApePat = infor[0].APEPAT;
                    this.txtApeMat = infor[0].APEMAT;
                    //this.txtCorreElec = infor[0].EMAIL;
                    this.contactForm.controls.correoContacto.setValue(infor[0].EMAIL);
                    this.txtTelef = infor[0].TELEFO;
                    this.txtMovil = infor[0].TELCEL;
                    //this.desactivaDatosCt = false;
                } else if (curp === 'G') { //Curp que pertenence a datos generales
                    this.txtNombreF = infor[0].NOMBRE;
                    this.txtApePatF = infor[0].APEPAT;
                    this.txtApeMatF = infor[0].APEMAT;
                    if (this.tipoPersona === 'FO' || this.tipoPersona === 'FA') {
                      //Representante tecnico
                      this.contactForm.controls.curpRt.setValue(infor[0].CURP);
                      this.txtRepreTec = infor[0].NOMBRE;
                      this.txtApePatRepreTec = infor[0].APEPAT;
                      this.txtApeMatRepreTec = infor[0].APEMAT;
                      this.contactForm.controls.correoRt.setValue(infor[0].EMAIL);
                      this.telefonoRt = infor[0].TELEFO;
                      this.telcelRt = infor[0].TELCEL;
                    }
                } else if (curp === 'RL') { //Curp del representante legal
                    this.txtRepreLeg = infor[0].NOMBRE;
                    this.txtApePatRepreLeg = infor[0].APEPAT;
                    this.txtApeMatRepreLeg = infor[0].APEMAT;
                    this.contactForm.controls.correoRl.setValue(infor[0].EMAIL);
                    this.telefonoRl = infor[0].TELEFO;
                    this.telcelRl = infor[0].TELCEL;
                } else if (curp === 'RT') { //Curp del representante tecnico
                    this.txtRepreTec = infor[0].NOMBRE;
                    this.txtApePatRepreTec = infor[0].APEPAT;
                    this.txtApeMatRepreTec = infor[0].APEMAT;
                    this.contactForm.controls.correoRt.setValue(infor[0].EMAIL);
                    this.telefonoRt = infor[0].TELEFO;
                    this.telcelRt = infor[0].TELCEL;
                }
            } else {
              //Curp que pertenece a Contacto
              if (curp === 'C') {
                  this.txtNombre = '';
                  this.txtApePat = '';
                  this.txtApeMat = '';
                  //this.txtCorreElec = '';
                  this.contactForm.controls.correoContacto.setValue('');
                  this.txtTelef = '';
                  this.txtMovil = '';
                  this.desactivaDatosCt = true;
              }
            }
          } else {
            this.mensajeError = data[0].msgRespuesta;
            setTimeout(() => {
              $('#mod_procesando').modal('hide');
              $('#error').modal('show');
           }, 500);
          }
        },
        error => {
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
            $('#error').modal('show');
         }, 500);
        });
    } else {
      //Curp que pertenece a Contacto
      if (curp === 'C') {
          this.txtNombre = '';
          this.txtApePat = '';
          this.txtApeMat = '';
          //this.txtCorreElec = '';
          this.contactForm.controls.correoContacto.setValue('');
          this.txtTelef = '';
          this.txtMovil = '';
          this.desactivaDatosCt = true;
      }
    }
  }

  //Limpia campos segun el tipo de persona y proveedor seleccionados, campos que no son usados
  limpiaCampos() {
    if (this.tipoPersona === 'MS') {
      this.txtNoCeduPadr = '';
      //this.txtCurpRepTec = '';
      this.contactForm.controls.curpRt.setValue('');
      this.txtRepreTec = '';
      this.txtApePatRepreTec = '';
      this.txtApeMatRepreTec = '';
      //this.correoRt = '';
      this.contactForm.controls.correoRt.setValue('');
      this.telefonoRt = '';
      this.telcelRt = '';
      //this.txtCurpF = '';
      this.contactForm.controls.curp.setValue('');
      this.txtNombreF = '';
      this.txtApePatF = '';
      this.txtApeMatF = '';
      this.txtActiEmp = '';
      this.txtNoCeduPadrF = '';
    } else if (this.tipoPersona === 'MO' || this.tipoPersona === 'MA') {
      // this.txtCurpF = '';
      this.contactForm.controls.curp.setValue('');
      this.txtNombreF = '';
      this.txtApePatF = '';
      this.txtApeMatF = '';
      this.txtActiEmp = '';
      this.txtNoCeduPadrF = '';
    } else if (this.tipoPersona === 'FS') {
      this.txtNoCeduPadrF = '';
      this.txtNombreComercial = '';
      this.txtRazonSocial = this.txtNombreF + ' ' + this.txtApePatF + ' ' + this.txtApeMatF;
      this.txtObjetoSocial = '';
      this.selEstratificacion = '0';
      this.selRepresentante = '99';
      //this.txtCurpRepLegal = '';
      this.contactForm.controls.curpRl.setValue('');
      this.txtRepreLeg = '';
      this.txtApePatRepreLeg = '';
      this.txtApeMatRepreLeg = '';
      this.fkcpersRl = '';
      //this.correoRl = '';
      this.contactForm.controls.correoRl.setValue('');
      this.telefonoRl = '';
      this.telcelRl = '';
      this.txtNoCeduPadr = '';
      //this.txtCurpRepTec = '';
      this.contactForm.controls.curpRt.setValue('');
      this.txtRepreTec = '';
      this.txtApePatRepreTec = '';
      this.txtApeMatRepreTec = '';
      this.fkcpersRt = '';
      //this.correoRt = '';
      this.contactForm.controls.correoRt.setValue('');
      this.telefonoRt = '';
      this.telcelRt = '';
    } else if (this.tipoPersona === 'FO' || this.tipoPersona === 'FA' || this.tipoPersona === 'FP') {
      this.txtNombreComercial = '';
      this.txtRazonSocial = this.txtNombreF + ' ' + this.txtApePatF + ' ' + this.txtApeMatF;
      this.txtObjetoSocial = '';
      this.selEstratificacion = '0';
      this.selRepresentante = '99';
      //this.txtCurpRepLegal = '';
      this.contactForm.controls.curpRl.setValue('');
      this.txtRepreLeg = '';
      this.txtApePatRepreLeg = '';
      this.txtApeMatRepreLeg = '';
      this.fkcpersRl = '';
      //this.correoRl = '';
      this.contactForm.controls.correoRl.setValue('');
      this.telefonoRl = '';
      this.telcelRl = '';
      this.txtNoCeduPadr = '';
    }
  }

  //Cerrar sesion para cuando vence el token
  cerrarSesion() {
    this.apiAuth.deleteToken();
    this.router.navigate(['/']).then(() => window.location.reload());
  }


  //Cargar informacion
  cargaInformacion() {
    //Carga información guardada
    let proveedor: Proveedor;
    proveedor = this.apiAuth.getTokenDecoded();
    //Comprueba el estado para mostrar o no el boton de Ver Datos Generales
    if (proveedor.Tipo === '2' || proveedor.Tipo === '1' || proveedor.Tipo === '6'|| proveedor.Tipo === '5'|| proveedor.Tipo === '3') {
      this.bloquea = true;
    } else {
      this.bloquea = false;
    }

    if(proveedor.TipoProv === '1'){
      this.bloqTip = true;
    }else{
      this.bloqTip = false;
    }
    this.apiRegistry.getInformacionRfc(proveedor.RFC).subscribe(data => {
      if (data[0].success) {
        if (data[0].info !== '{}' && data[0].info !== '[]') {
          let datos = data[0].info;
          datos = JSON.parse(datos);
          //console.log(datos);
          this.etiquetCveProv = datos[0].CLAVEPROV;
          this.etiquetaEstatus = datos[0].ESTATUS_DESCRI;
          this.cargaDatos(datos);
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
         }, 500);
        } else {
          //Seleccionar Situacion Fiscal con respescto a su RFC  12 digitos -> MORAL, 13 digitos -> FISICA
          if (proveedor.RFC.length === 12) {
            this.radioSituacion = '2';
          } else if (proveedor.RFC.length === 13) {
            this.radioSituacion = '1';
          }
          let radioSit = this.radioSituacion == '1' ? 'F' : 'M';
          this.radioTipo = proveedor.TipoProv === '1'?'P':'S';
          this.radioProveedor = proveedor.TipoProv === '1'?'P':'S';

          this.tipoPersona = radioSit + this.radioTipo;
          this.getPaises('1');

        }
      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
       }, 500);
      }
      //this.getGiros();
      this.getEstratificacion();
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    });
  }

  //Obtiene los grados
  getGradoEstudios() {
    let cveLov = 'LOVGRAESTU';
    this.apiRegistry.getLovs(cveLov).subscribe(data => {
      if (data[0].success) {
        let gir = data[0].info;
        this.datagrados = JSON.parse(gir);
        //this.getPaises();
      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
       }, 500);
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
          this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
          this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    });
  }

  //Obtiene los grados
  getPaises(cvePais) {
    let cveLov = 'LOVPAIS';
    this.apiRegistry.getLovs(cveLov).subscribe(data => {
      if (data[0].success) {

        let paises = data[0].info;
        this.datapaises = JSON.parse(paises);

        //this.selPais = '1';

        this.getEstados(cvePais,-1);
      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
       }, 500);
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
          this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
          this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    });
  }

  //Obtiene los grados
  getEstados(cvePais,cveEstado) {
    let cveLov = 'LOVESTAF';
    let cadena = 'VLP_PAIS:cadena=' + cvePais;
    this.apiRegistry.getLovs(cveLov,cadena).subscribe(data => {
      if (data[0].success) {
        let estad = data[0].info;
        this.dataestados = JSON.parse(estad);
        this.selEstados = cveEstado;
        /*if(cvePais ==='1'){
          this.getCiudades(this.dataestados[0].CLAVE,this.selCiud);
        }else {*/
        //  this.selEstados = cveEstado;
        //}
      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
       }, 500);
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
          this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
          this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    });
  }
//Obtiene los grados
getCiudades(cveEstado,ciudad) {
  let cveLov = 'LOVCIUD';
  let cadena = 'VPS_ESTADO:cadena=' + cveEstado;
  this.apiRegistry.getLovs(cveLov,cadena).subscribe(data => {

    if (data[0].success) {
      let ciud = data[0].info;
      this.dataciud = JSON.parse(ciud);
      if(this.selEstados === '-1'){this.selCiud = '-1';}
      this.selCiud = ciudad;
    } else {
      this.mensajeError = data[0].msgRespuesta;
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    }
  },
  error => {
    this.error = error.status;
    if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
    } else  {
        this.mensajeError = '¡Error!';
    }
    setTimeout(() => {
      $('#mod_procesando').modal('hide');
      $('#error').modal('show');
   }, 500);
  });
}

cambioPais(event) {
  let cvePais = event.target.value;

  this.getEstados(cvePais,-1);

}

cambioEstados(event) {
  let cveEstado = event.target.value;
  this.getCiudades(cveEstado,-1);
}

cambiaNivel(event){

  let posi = this.ubicarNivel(event.target.value);

  if(this.datagrados[posi].PRIORI>=7){
    this.ocultaCed = true;
  }else{
    this.ocultaCed = false;
  }

}
ubicarNivel(valor){
  let posicion = 0;
  for(let i=0;i<this.datagrados.length;i++){
     if( this.datagrados[i].CLAVE ==valor){
      posicion = i;
     }

  }
  return posicion;
}

getPaisesDatGen(cvePais,cveEstado,cveCiud) {
  let cveLov = 'LOVPAIS';
  this.apiRegistry.getLovs(cveLov).subscribe(data => {
    if (data[0].success) {

      let paises = data[0].info;
      this.datapaises = JSON.parse(paises);

      //this.selPais = '1';
      if(cvePais == ""){
        this.selPais = '-1';
        this.selEstados = '-1';
      }

      this.getEstadosDatGen(cvePais,cveEstado,cveCiud);

    } else {
      this.mensajeError = data[0].msgRespuesta;
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    }
  },
  error => {
    this.error = error.status;
    if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
    } else  {
        this.mensajeError = '¡Error!';
    }
    setTimeout(() => {
      $('#mod_procesando').modal('hide');
      $('#error').modal('show');
   }, 500);
  });
}

getEstadosDatGen(cvePais,cveEstado,cveCiud) {
  let cveLov = 'LOVESTAF';
  let cadena = 'VLP_PAIS:cadena=' + cvePais;
  this.apiRegistry.getLovs(cveLov,cadena).subscribe(data => {
    if (data[0].success) {
      let estad = data[0].info;
      this.dataestados = JSON.parse(estad);
      this.selEstados = cveEstado;

      if(cvePais ==='1'){
        this.getCiudades(cveEstado,cveCiud);
      }else {
        this.selEstados = cveEstado;
      }
    } else {
      this.mensajeError = data[0].msgRespuesta;
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    }
  },
  error => {
    this.error = error.status;
    if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
    } else  {
        this.mensajeError = '¡Error!';
    }
    setTimeout(() => {
      $('#mod_procesando').modal('hide');
      $('#error').modal('show');
   }, 500);
  });
}

}

